import {History} from 'history';
import {logWithSentry} from 'libs/sentry/sentry';

import {fetchSearchResults} from './fetchSearchResults';
import {handleSearchResponse} from './handleSearchResponse';

type PropsType = {
    query: string;
    history: History<unknown>;
};

/**
 * function handleFetchSearchResults calling handleSearchResponse / logWithSentry after fetching (tested in modules/features/quickSearch/components/quickSearch.test.tsx)
 */
export const handleFetchSearchResults = ({query, history}: PropsType): void => {
    fetchSearchResults(query)
        .then(response => {
            handleSearchResponse(history.push, query, response);
        })
        .catch(error => {
            logWithSentry(error, 'Search failed');
        });
};
